import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setProductSettingsData } from "redux/actions";

/**
 * Returns the operator's product settings from redux, fetching them once if nothing has
 * loaded them yet.
 *
 * Product settings are written to redux only by the Product and Settings pages, so any
 * page that merely reads them (inventory METRC columns, bulk import, ...) saw defaults —
 * i.e. features switched off — for a user who hadn't opened product settings in this
 * session. Pages that gate UI on a setting should read it through this hook.
 */
const useProductSettings = () => {
  const dispatch = useDispatch();
  const productSettingsData = useSelector(
    (state) => state.initialLoadReducer?.productSettingsData
  );
  const loaded = Boolean(productSettingsData && Object.keys(productSettingsData).length);

  useEffect(() => {
    if (loaded) return;
    window
      .axiosIns("/products_settings")
      .then(({ data = {} }) => {
        dispatch(setProductSettingsData(data.results?.[0] ?? {}));
      })
      .catch((err) => console.log("Could not load product settings", err));
  }, [loaded, dispatch]);

  return productSettingsData || {};
};

export default useProductSettings;
